import actions from './constants';
import { defaultEvent } from './helper';

export const showSubscribers = (
  category,
  code,
  event,
  name,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_SUBSCRIBERS,
  category,
  code,
  name,
  event,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showSubscribersError = (category, code, event, error) => ({
  type: actions.SHOW_SUBSCRIBERS_ERROR,
  category,
  code,
  event,
  error,
});

export const closeSubscribers = ({ category, code }) => ({
  type: actions.CLOSE_SUBSCRIBERS,
  category,
  code,
  event: defaultEvent(category),
});
